import React, { useState, useEffect } from 'react';
import { onAuthStateChanged,signOut } from "firebase/auth";
import {auth} from "../firebase-config";
import Menu from './navbar.component'
// export default class Login extends Component {
const Panel = () => {
    const [user,setUser] = useState({});
    const [open,setOpen] = useState(false);
    useEffect(() => {
        onAuthStateChanged(auth, async (currentUser) => {
          setUser(currentUser);
          if (currentUser && currentUser!=null) {
            setOpen(true);
          }else{
            window.location = "/";
          }
        });
      }, []);
  // render() {
    return (
      <div>
        { (open) ? <Menu user={user} />: "" }
      </div>
    )
  // }
}

export default Panel;